const getters = {
  ProjectRecord: ({ slug }) => `/${slug}`,
};

export const getProjectPath = (slug) => getters.ProjectRecord({ slug });

export default function getPath(record, path = "") {
  const getter = getters[record?.__typename];
  if (!getter) return "/";
  return getter(record) + path;
}

export {};
